var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "transparent", attrs: { id: "inspire", app: "" } },
    [
      _c("SlideLeft", {
        attrs: { stretch: _vm.stretchL, naviData: _vm.naviData },
      }),
      _c("Navi", {
        attrs: { popR: _vm.popR, stretchL: _vm.stretchL },
        on: {
          onStretch: function (s) {
            _vm.stretchL = s
          },
          onPop: function (s) {
            _vm.popR = s
          },
        },
      }),
      _c("Container", {
        attrs: {
          stretch: _vm.popR,
          stretchL: _vm.stretchL,
          stretchR: _vm.stretchR,
        },
        on: {
          slideRightChange: function ($event) {
            _vm.stretchR = !_vm.stretchR
          },
          onPopChange: function (s) {
            _vm.popR = s
          },
        },
      }),
      _c("SlideRight", {
        attrs: { hidden: _vm.isHidden, stretch: _vm.stretchR },
        on: {
          onStretch: function (s) {
            _vm.stretchR = s
          },
        },
      }),
      _c("MsgStatus"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }